// 与 web-index / ssr-web-index 路由语言一致，否则 /zh-CN/accounts/login 会被 Next 当成非法 locale 再套一层默认语言成 /en/zh-CN/... 404
export default [
  { key: "en", name: "en", lab: "English" },
  { key: "pt", name: "pt", lab: "Português" },
  { key: "ar", name: "ar", lab: "العربية" },
];
